export const USER_SETTINGS_ADD = 'USER_SETTINGS_ADD'
